<template>
  <v-main class="document pt-5" style="margin: 0 auto">
    <v-container v-if="!loading && !error" class="container-print">
      <div class="row px-6 pt-3 pb-3">
        <div class="pl-0">
          <h4 class="black--text">{{ documentName }}</h4>
          <h1 class="primary--text">{{ celebration.name }}</h1>
        </div>
        <v-spacer></v-spacer>
        <div class="text-right primary--text">
          <img src="@/assets/logo-heppi.png" srcset="@/assets/logo-heppi@2x.png 2x" style="height: 45px" />
        </div>
      </div>
      <div class="row" v-if="sections.has('totals')">
        <div class="col-8 row no-gutters">
          <div class="col-6 pa-1">
            <div class="mb-2">
              <v-alert dense outlined color="grey lighten-2" class="mb-0">
                <div class="row">
                  <div class="col-12 black--text text-right text-bold" style="line-height: 1em;">
                    <small class="caption grey--text">Meta</small>
                    <br>
                    {{ celebration.amount_to_pay | price }}
                  </div>
                </div>
              </v-alert>
            </div>
            <v-alert dense outlined color="success lighten-4" class="mb-0">
              <div class="row">
                <div class="col-12 black--text text-right" style="line-height: 1em;">
                  <small class="caption success--text">Arrecadado por fora</small>
                  <br>
                  {{ celebration.paid_before | price }}
                </div>
                <div class="col-12 black--text text-right" style="line-height: 1em;">
                  <small class="caption success--text">Arrecadado pela Heppi</small>
                  <br>
                  {{ celebration.paid_without_interest_and_fine | price }}
                </div>
                <div class="col-12 black--text text-right" style="line-height: 1em;">
                  <small class="caption success--text">Juros pago</small>
                  <br>
                  {{ celebration.paid_interest_and_fine | price }}
                </div>
                <div v-if="celebration.transfers_credit" class="col-12 black--text text-right" style="line-height: 1em;">
                  <small class="caption success--text">Transferências (crédito)</small>
                  <br>
                  {{ celebration.transfers_credit | price }}
                </div>
                <div v-if="celebration.cashback" class="col-12 black--text text-right" style="line-height: 1em;">
                  <small class="caption success--text">Cashback Heppi</small>
                  <br>
                  {{ celebration.cashback | price }}
                </div>
              </div>
            </v-alert>
          </div>
          <div class="col-6">
            <div class="row no-gutters">
              <div class="col-12 pa-1">
                <v-alert dense outlined color="red lighten-4" class="mb-0">
                  <div class="row">
                    <div class="col-12 black--text text-right" style="line-height: 1em;">
                      <small class="caption red--text">Total atrasado</small>
                      <br>
                      {{ celebration.late | price }}
                    </div>
                  </div>
                </v-alert>
              </div>
              <div class="col-12 pa-1">
                <v-alert dense outlined color="grey lighten-2" class="mb-0">
                  <div class="row">
                    <div class="col-12 black--text text-right" style="line-height: 1em;">
                      <small class="caption grey--text">Em aberto</small>
                      <br>
                      {{ celebration.pending | price }}
                    </div>
                  </div>
                </v-alert>
              </div>
              <div v-if="celebration.withdraws" class="col-12 pa-1">
                <v-alert dense outlined color="grey lighten-2" class="mb-0">
                  <div class="row">
                    <div class="col-12 black--text text-right" style="line-height: 1em;">
                      <small class="caption grey--text">Resgates</small>
                      <br>
                      - {{ celebration.withdraws | price }}
                    </div>
                  </div>
                </v-alert>
              </div>
              <div v-if="celebration.heppiPlan" class="col-12 pa-1">
                <v-alert dense outlined color="grey lighten-2" class="mb-0">
                  <div class="row">
                    <div class="col-12 black--text text-right" style="line-height: 1em;">
                      <small class="caption grey--text">Heppi Assessoria</small>
                      <br>
                      - {{ celebration.heppiPlan | price }}
                    </div>
                  </div>
                </v-alert>
              </div>
              <div v-if="celebration.waivers" class="col-12 pa-1">
                <v-alert dense outlined color="grey lighten-2" class="mb-0">
                  <div class="row">
                    <div class="col-12 black--text text-right" style="line-height: 1em;">
                      <small class="caption grey--text">Devolução (desistência)</small>
                      <br>
                      - {{ celebration.waivers | price }}
                    </div>
                  </div>
                </v-alert>
              </div>
              <div v-if="celebration.transfers_debit" class="col-12 pa-1">
                <v-alert dense outlined color="grey lighten-2" class="mb-0">
                  <div class="row">
                    <div class="col-12 black--text text-right" style="line-height: 1em;">
                      <small class="caption grey--text">Pagamento fornecedores</small>
                      <br>
                      - {{ celebration.transfers_debit | price }}
                    </div>
                  </div>
                </v-alert>
              </div>
              <div v-if="celebration.heppi_fee || celebration.heppi_fee === 0" class="col-12 pa-1">
                <v-alert dense outlined color="grey lighten-2" class="mb-0">
                  <div class="row">
                    <div class="col-12 black--text text-right" style="line-height: 1em;">
                      <small class="caption grey--text">Taxa Heppi</small>
                      <br>
                      - {{ celebration.heppi_fee | price }}
                    </div>
                  </div>
                </v-alert>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="row no-gutters">
            <div class="col-12 pa-1">
              <v-alert dense color="success" class="mb-0">
                <div class="row">
                  <div class="col-12 white--text text-right" style="line-height: 1em;">
                    <small class="caption white--text">Saldo</small>
                    <br>
                    <h3 class="tex-bold">{{ celebration.available_balance | price }}</h3>
                  </div>
                </div>
              </v-alert>
            </div>
            <div class="col-12 pa-1">
              <v-alert dense outlined color="success lighten-4" class="mb-0">
                <div class="row">
                  <div class="col-12 black--text text-right" style="line-height: 1em;">
                    <small class="caption success--text">Saldo à liberar</small>
                    <br>
                    {{ celebration.unavailable_balance | price }}
                  </div>
                </div>
              </v-alert>
            </div>
            <!-- <div class="col-12 pa-1">
              <v-alert dense outlined color="success lighten-4" class="mb-0">
                <div class="row">
                  <div class="col-12 black--text text-right" style="line-height: 1em;">
                    <small class="caption success--text">Cashback Heppi</small>
                    <br>
                    {{ celebration.cashback | price }}
                  </div>
                </div>
              </v-alert>
            </div> -->
            <div class="col-12 pa-1">
              <v-alert dense outlined color="blue lighten-4" class="mb-0">
                <div class="row">
                  <div class="col-12 black--text text-right" style="line-height: 1em;">
                    <small class="caption blue--text">Total a receber *</small>
                    <br>
                    {{ celebration.pending + celebration.late | price }}
                  </div>
                </div>
              </v-alert>
            </div>
            <div class="col-12 caption pa-4" style="line-height: 1.2em;">
              * Valor disponível caso o atrasado e o a receber se realizem
            </div>
          </div>
        </div>
      </div>
      <div class="pt-5" v-if="sections.has('fundraisings')">
        <h4 class="primary--text text-bold">Arrecadações</h4>
        <v-divider class="mb-1" />
        <div class="caption">Totais resumidos das arrecadações</div>
        <v-data-table
          class="pt-4"
          dense
          :headers="fundraisingHeaders"
          :items="fundraisings"
          :loading="loading"
          :disable-pagination="true"
          no-data-text="Nenhuma arrecadação"
          no-results-text="Nenhum arrecadação"
          :hide-default-footer="true"
        >
          <template v-slot:item.amount_to_pay="{ item }">
            <span style="white-space: nowrap">{{ item.amount_to_pay | price }}</span>
          </template>
          <template v-slot:item.paid="{ item }">
            <span style="white-space: nowrap">{{ item.paid_before + item.paid_without_interest_and_fine | price }}</span>
          </template>
          <template v-slot:item.paid_before="{ item }">
            <span style="white-space: nowrap">{{ item.paid_before | price }}</span>
          </template>
          <template v-slot:item.paid_without_interest_and_fine="{ item }">
            <span style="white-space: nowrap">{{ item.paid_without_interest_and_fine | price }}</span>
          </template>
          <template v-slot:item.paid_interest_and_fine="{ item }">
            <span style="white-space: nowrap">{{ item.paid_interest_and_fine | price }}</span>
          </template>
          <template v-slot:item.late="{ item }">
            <span style="white-space: nowrap">{{ item.late | price }}</span>
          </template>
          <template v-slot:item.pending="{ item }">
            <span style="white-space: nowrap">{{ item.pending | price }}</span>
          </template>
        </v-data-table>
        <div class="caption pt-2">* Valor arrecadado por fora + valor arrecadado na Heppi</div>
      </div>
      <div class="pt-8" v-if="sections.has('cashback') && cashbackData && cashbackData.length > 0">
        <h4 class="primary--text text-bold">Cashback Heppi</h4>
        <v-divider class="mb-1" />
        <div class="caption">Cashback dado pela heppi</div>
        <v-data-table
          class="pt-4"
          dense
          :headers="cashbackHeaders"
          :items="cashbackData"
          :loading="loading"
          :disable-pagination="true"
          no-data-text="Nenhum cashback"
          no-results-text="Nenhum cashback"
          :hide-default-footer="true"
        >
          <template v-slot:item.amount="{ item }">
            <span style="white-space: nowrap;">{{ item.amount | price }}</span>
          </template>
          <template v-slot:item.paymentDate="{ item }">
            {{ item.paymentDate | moment('DD/MM/YYYY') }}
          </template>
        </v-data-table>
      </div>
      <div class="pt-8" v-if="sections.has('credits') && credits && credits.length > 0">
        <h4 class="primary--text text-bold">Outras entradas</h4>
        <v-divider class="mb-1" />
        <div class="caption">Valores que entraram de outras formas, como por exemplo saldo restante de outra arrecadação ou experiência</div>
        <v-data-table
          class="pt-4"
          dense
          :headers="transferHeaders"
          :items="credits"
          :loading="loading"
          :disable-pagination="true"
          no-data-text="Nenhuma transferência"
          no-results-text="Nenhuma transferência"
          :hide-default-footer="true"
        >
          <template v-slot:item.amount="{ item }">
            <span style="white-space: nowrap;">{{ item.amount | price }}</span>
          </template>
          <template v-slot:item.paymentDate="{ item }">
            {{ item.paymentDate | moment('DD/MM/YYYY') }}
          </template>
        </v-data-table>
      </div>
      <div class="pt-8" v-if="sections.has('waivers') && waivers && waivers.length > 0">
        <h4 class="primary--text text-bold">Devoluções por desistência</h4>
        <v-divider class="mb-1" />
        <v-data-table
          dense
          class="pt-4"
          :headers="transferHeaders"
          :items="waivers"
          :loading="loading"
          :disable-pagination="true"
          no-data-text="Nenhuma transferência"
          no-results-text="Nenhuma transferência"
          :hide-default-footer="true"
        >
          <template v-slot:item.amount="{ item }">
            <span style="white-space: nowrap;">{{ item.amount | price }}</span>
          </template>
          <template v-slot:item.paymentDate="{ item }">
            {{ item.paymentDate | moment('DD/MM/YYYY') }}
          </template>
        </v-data-table>
      </div>
      <div class="pt-8" v-if="sections.has('withdraws') && withdrawsData && withdrawsData.length > 0">
        <h4 class="primary--text text-bold">Resgates</h4>
        <v-divider class="mb-1" />
        <div class="caption">Solicitações de resgate pelo App que vão para a conta cadastrada da turma</div>
        <v-data-table
          class="pt-4"
          dense
          :headers="withdrawHeaders"
          :items="withdrawsData"
          :loading="loading"
          :disable-pagination="true"
          no-data-text="Nenhum resgate"
          no-results-text="Nenhum resgate"
          :hide-default-footer="true"
        >
          <template v-slot:item.amount="{ item }">
            <span style="white-space: nowrap;">{{ item.amount | price }}</span>
          </template>
          <template v-slot:item.paymentDate="{ item }">
            {{ item.paymentDate | moment('DD/MM/YYYY') }}
          </template>
        </v-data-table>
      </div>
      <div class="pt-8" v-if="sections.has('transfers') && debits && debits.length > 0">
        <h4 class="primary--text text-bold">Pagamentos de fornecedores</h4>
        <v-divider class="mb-1" />
        <v-data-table
          dense
          class="pt-4"
          :headers="transferHeaders"
          :items="debits"
          :loading="loading"
          :disable-pagination="true"
          no-data-text="Nenhuma transferência"
          no-results-text="Nenhuma transferência"
          :hide-default-footer="true"
        >
          <template v-slot:item.amount="{ item }">
            <span style="white-space: nowrap;">{{ item.amount | price }}</span>
          </template>
          <template v-slot:item.paymentDate="{ item }">
            {{ item.paymentDate | moment('DD/MM/YYYY') }}
          </template>
        </v-data-table>
      </div>
      <div class="pt-8" v-if="sections.has('heppiPlan') && heppiPlanData && heppiPlanData.length > 0">
        <h4 class="primary--text text-bold">Heppi Assessoria Financeira</h4>
        <v-divider class="mb-1" />
        <div class="caption">Mensalidades referentes ao Plano de Assessoria Financeira da Heppi</div>
        <v-data-table
          class="pt-4"
          dense
          :headers="heppiPlanHeaders"
          :items="heppiPlanData"
          :loading="loading"
          :disable-pagination="true"
          no-data-text="Nenhuma mensalidade"
          no-results-text="Nenhuma mensalidade"
          :hide-default-footer="true"
        >
          <template v-slot:item.amount="{ item }">
            <span style="white-space: nowrap;">{{ item.amount | price }}</span>
          </template>
          <template v-slot:item.paymentDate="{ item }">
            {{ item.paymentDate | moment('DD/MM/YYYY') }}
          </template>
        </v-data-table>
      </div>
      <div class="pt-4 text-right">
        <i class="caption">Documento gerado no dia {{ now }}</i>
      </div>
    </v-container>
    <div v-if="error" style="margin: 50px auto; max-width: 300px; text-align: center;">
      Houve um erro ao processar o relatório, por favor tente novamente
    </div>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations, mapGetters, mapActions } from 'vuex'
import AppLoading from '@/components/Loading'

export default {
  name: 'celebrationPrint',
  components: {
    AppLoading
  },
  props: ['celebrationId'],
  data: () => ({
    loading: false,
    openDialog: false,
    documentName: 'Resumo Financeiro',
    sections: new Set(['totals', 'fundraisings', 'cashback', 'credits', 'waivers', 'withdrals', 'transfers', 'heppiPlan']),
    celebration: {
      name: '',
      accountId: null,
      amount_to_pay: 0,
      paid_before: 0,
      paid_without_interest_and_fine: 0,
      paid_interest_and_fine: 0,
      late: 0,
      pending: 0,
      waivers: 0,
      transfers_debit: 0,
      transfers_credit: 0,
      withdraws: 0,
      heppiPlan: 0,
      cashback: 0,
      heppi_fee: null,
      ignore_transfers: [],
      available_balance: 0,
      unavailable_balance: 0
    },
    fundraisings: [],
    fundraisingHeaders: [
      {
        text: 'Nome',
        value: 'name',
        sortable: false
      },
      {
        text: 'Meta',
        value: 'amount_to_pay',
        align: 'right',
        sortable: false
      },
      {
        text: 'Arrecadado *',
        value: 'paid',
        align: 'right',
        sortable: false
      },
      // {
      //   text: 'Pago por fora',
      //   value: 'paid_before',
      //   align: 'right',
      //   sortable: false
      // },
      // {
      //   text: 'Pago Heppi',
      //   value: 'paid_without_interest_and_fine',
      //   align: 'right',
      //   sortable: false
      // },
      // {
      //   text: 'Juros pago',
      //   value: 'paid_interest_and_fine',
      //   align: 'right',
      //   sortable: false
      // },
      {
        text: 'Atrasado',
        value: 'late',
        align: 'right',
        sortable: false
      },
      {
        text: 'Em aberto',
        value: 'pending',
        align: 'right',
        sortable: false
      }
    ],
    transferHeaders: [
      {
        text: 'Data',
        value: 'paymentDate',
        sortable: false
      },
      {
        text: 'Valor',
        value: 'amount',
        align: 'right',
        sortable: false
      },
      {
        text: 'Fornecedor',
        value: 'provider',
        sortable: false
      },
      {
        text: 'Descrição',
        value: 'description',
        sortable: false
      }
    ],
    withdrawHeaders: [
      {
        text: 'Data',
        value: 'paymentDate',
        sortable: false
      },
      {
        text: 'Valor',
        value: 'amount',
        align: 'right',
        sortable: false
      },
      {
        text: 'Descrição',
        value: 'description',
        sortable: false
      }
    ],
    heppiPlanHeaders: [
      {
        text: 'Data',
        value: 'paymentDate',
        sortable: false
      },
      {
        text: 'Valor',
        value: 'amount',
        align: 'right',
        sortable: false
      },
      {
        text: 'Descrição',
        value: 'description',
        sortable: false
      }
    ],
    cashbackHeaders: [
      {
        text: 'Referência',
        value: 'description',
        sortable: false
      },
      {
        text: 'Valor',
        value: 'amount',
        align: 'right',
        sortable: false
      },
      {
        text: 'Liberado em',
        value: 'paymentDate',
        sortable: false
      }
    ],
    joinedHeaders: [
      {
        text: 'Nome',
        value: 'name'
      },
      {
        text: 'Meta',
        value: 'amount_to_pay'
      },
      {
        text: 'Pago por fora',
        value: 'total_paid_before'
      },
      {
        text: 'Pago Heppi',
        value: 'total_paid_without_interest_and_fine'
      },
      {
        text: 'Juros pago',
        value: 'total_paid_interest_and_fine'
      },
      {
        text: 'Atrasado',
        value: 'total_late'
      },
      {
        text: 'Em aberto',
        value: 'total_pending'
      }
    ],
    now: '',
    error: false
  }),
  computed: {
    ...mapGetters(['transfers', 'withdraws', 'heppiPlan', 'cashback']),
    items () {
      if (this.celebration.accountId) {
        let transfers = this.transfers(this.celebration.accountId).map(e => {
          return {
            id: e._id.$oid,
            processor: (e.processor === 'iugu') ? 'IUGU' : 'MP',
            financialType: (e.financial_type === 'credit') ? 'Entrada' : 'Saída',
            paymentDate: this.$moment(e.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('YYYY-MM-DD HH:mm'),
            provider: e.sender ? e.sender.name : e.receiver ? e.receiver.name : '',
            providerID: e.sender ? e.sender.id : e.receiver ? e.receiver.id : '',
            description: e.description,
            amount: e.amount
          }
        }).filter(e => !this.celebration.ignore_transfers.includes(e.id) && (!this.celebration.base_account || this.celebration.base_account !== e.providerID))

        if (this.celebration.base_account) {
          const transfersBase = this.transfers(this.celebration.base_account).map(e => {
            return {
              id: e._id.$oid,
              processor: (e.processor === 'iugu') ? 'IUGU' : 'MP',
              financialType: (e.financial_type === 'credit') ? 'Entrada' : 'Saída',
              paymentDate: this.$moment(e.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('YYYY-MM-DD HH:mm'),
              provider: e.sender ? e.sender.name : e.receiver ? e.receiver.name : '',
              providerID: e.sender ? e.sender.id : e.receiver ? e.receiver.id : '',
              description: e.description,
              amount: e.amount
            }
          }).filter(e => this.celebration.accountId !== e.providerID)
          if (transfersBase && transfersBase.length > 0) transfers = [...transfers, ...transfersBase]
        }

        transfers.sort((a, b) => parseInt(this.$moment(a.paymentDate).format('X')) - parseInt(this.$moment(b.paymentDate).format('X')))
        return transfers
      }
      return []
    },
    waivers () {
      return this.items.filter(e => e.financialType === 'Saída' && e.description.toLowerCase().search('desist') > 0)
    },
    credits () {
      return this.items.filter(e => e.financialType === 'Entrada')
    },
    debits () {
      return this.items.filter(e => e.financialType === 'Saída' && !this.waivers.find(w => w.id === e.id))
    },
    withdrawsData () {
      if (this.celebration.accountId) {
        return this.withdraws(this.celebration.accountId).map(e => {
          return {
            id: e._id.$oid,
            processor: (e.processor === 'iugu') ? 'IUGU' : 'MP',
            paymentDate: this.$moment(e.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('YYYY-MM-DD HH:mm'),
            description: e.description,
            amount: e.amount
          }
        })
      }
      return []
    },
    heppiPlanData () {
      if (this.celebration.accountId) {
        return this.heppiPlan(this.celebration.accountId).map(e => {
          return {
            id: e._id.$oid,
            processor: (e.processor === 'iugu') ? 'IUGU' : 'MP',
            paymentDate: this.$moment(e.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('YYYY-MM-DD HH:mm'),
            description: e.description,
            amount: e.amount
          }
        })
      }
      return []
    },
    cashbackData () {
      if (this.celebration.accountId) {
        const cashbackData = []
        const cashbackDataAcc = {}
        for (const index in this.cashback(this.celebration.accountId)) {
          const cashbackItem = this.cashback(this.celebration.accountId)[index]
          const splitDesc = cashbackItem.description.split(' ')
          const paymentDate = this.$moment(cashbackItem.payment_date.$date, 'YYYY-MM-DD[T]HH:mm[.000Z]').format('YYYY-MM-DD')
          console.log(paymentDate)
          if (splitDesc.length === 2 && splitDesc[1] && parseInt(splitDesc[1]) > 2000 && parseInt(splitDesc[1]) < 2100) {
            if (!cashbackDataAcc[splitDesc[1]]) {
              console.log('novo', splitDesc[0], splitDesc[1])
              cashbackDataAcc[splitDesc[1]] = {
                id: cashbackItem._id.$oid,
                processor: (cashbackItem.processor === 'iugu') ? 'IUGU' : 'MP',
                paymentDate,
                description: [splitDesc[0]],
                amount: cashbackItem.amount
              }
            } else { // if (cashbackDataAcc[splitDesc[1]].paymentDate === paymentDate) {
              cashbackDataAcc[splitDesc[1]].amount += cashbackItem.amount
              cashbackDataAcc[splitDesc[1]].description.push(splitDesc[0])
            }
          } else {
            cashbackData.push({
              id: cashbackItem._id.$oid,
              processor: (cashbackItem.processor === 'iugu') ? 'IUGU' : 'MP',
              paymentDate,
              description: cashbackItem.description,
              amount: cashbackItem.amount
            })
          }
        }
        if (Object.keys(cashbackDataAcc).length > 0) {
          for (const key in cashbackDataAcc) {
            const cashbackItem = cashbackDataAcc[key]
            let description = key + ' (' + cashbackItem.description[0]
            if (cashbackItem.description.length > 1) description += ' - ' + cashbackItem.description[cashbackItem.description.length - 1]
            description += ')'
            cashbackData.push({
              id: cashbackItem.id,
              processor: cashbackItem.processor,
              paymentDate: cashbackItem.paymentDate,
              description,
              amount: cashbackItem.amount
            })
          }
        }
        return cashbackData
      }
      return []
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    ...mapActions(['fetchTransfers'])
  },
  async created () {
    if (this.celebrationId) {
      this.loading = true
      let error = false

      if (this.$route && this.$route.query && this.$route.query.title) {
        this.documentName = this.$route.query.title
      }

      if (this.$route && this.$route.query && this.$route.query.sections) {
        this.sections = new Set(this.$route.query.sections)
      }

      if (this.$route && this.$route.query && this.$route.query.heppi_fee) {
        this.celebration.heppi_fee = parseFloat(this.$route.query.heppi_fee) || 0
      }

      if (this.$route && this.$route.query && this.$route.query.ignore_transfers) {
        const ignoreTransfersArray = this.$route.query.ignore_transfers.split(',')
        this.celebration.ignore_transfers = ignoreTransfersArray.map(e => e.trim()) || []
      }

      if (this.$route && this.$route.query && this.$route.query.base_account) {
        this.celebration.base_account = this.$route.query.base_account || null
      }

      await axios.get('celebrations/' + this.celebrationId)
        .then(response => {
          if (response.data) {
            this.celebration.name = response.data.name
            this.celebration.accountId = response.data.gateway_id
          } else {
            error = true
          }
        })
        .catch(() => { error = true })

      // Busca só as categorias necessárias baseado nas seções selecionadas
      if (this.celebration.accountId) {
        const sectionToCategory = {
          withdraws: 'request_withdraw',
          transfers: 'transfer',
          heppiPlan: 'heppi_plan',
          cashback: 'cashback',
          credits: 'transfer',
          waivers: 'transfer'
        }
        const categories = [...new Set(
          Object.entries(sectionToCategory)
            .filter(([section]) => this.sections.has(section))
            .map(([, cat]) => cat)
        )]
        if (categories.length > 0) {
          await Promise.all(categories.map(cat =>
            this.fetchTransfers({ accountId: this.celebration.accountId, category: cat })
          ))
          if (this.celebration.base_account) {
            await Promise.all(categories.map(cat =>
              this.fetchTransfers({ accountId: this.celebration.base_account, category: cat })
            ))
          }
        }
      }

      await axios.get('fundraisings?filter[celebration_id]=' + this.celebrationId)
        .then(response => {
          this.fundraisings = response.data.data.map(e => {
            return {
              name: e.name,
              id: e.id,
              amount_to_pay: 0,
              paid_before: 0,
              paid_without_interest_and_fine: 0,
              paid_interest_and_fine: 0,
              late: 0,
              pending: 0
            }
          })
        })
        .catch(() => { error = true })

      for (const index in this.fundraisings) {
        await axios.get('fundraisings/' + this.fundraisings[index].id)
          .then(response => {
            if (response.data) {
              let amount_to_pay = 0
              let paid_before = 0
              let paid_without_interest_and_fine = 0
              let paid_interest_and_fine = 0
              let late = 0
              let pending = 0

              for (const pIndex in response.data.participants) {
                const participant = response.data.participants[pIndex]
                amount_to_pay += parseFloat(participant.amount_to_pay)
                paid_before += (parseFloat(participant.total_paid_before) > 0) ? parseFloat(participant.total_paid_before) : 0
                paid_without_interest_and_fine += parseFloat(participant.total_paid_without_interest_and_fine)
                paid_interest_and_fine += parseFloat(participant.total_paid_interest_and_fine)
                late += parseFloat(participant.total_late)
                pending += parseFloat(participant.amount_to_pay) - parseFloat(participant.total_paid_before) - parseFloat(participant.total_paid_without_interest_and_fine) - parseFloat(participant.total_late)
              }

              this.fundraisings[index] = {
                ...this.fundraisings[index],
                amount_to_pay,
                paid_before,
                paid_without_interest_and_fine,
                paid_interest_and_fine,
                late,
                pending
              }

              this.celebration.amount_to_pay += amount_to_pay
              this.celebration.paid_before += paid_before
              this.celebration.paid_without_interest_and_fine += paid_without_interest_and_fine
              this.celebration.paid_interest_and_fine += paid_interest_and_fine
              this.celebration.late += late
              this.celebration.pending += pending
            } else {
              error = true
            }

            if (this.$route && this.$route.query && this.$route.query.interest) {
              this.celebration.paid_interest_and_fine = this.$route.query.interest
            }
          })
          .catch(() => { error = true })
      }

      await axios.get('accounts/' + this.celebration.accountId + '?api_key=' + this.celebration.accountId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        .then(response => {
          if (response.data) {
            this.celebration.available_balance = response.data.available_balance
            this.celebration.unavailable_balance = response.data.unavailable_balance
          } else {
            error = true
          }
        })
        .catch(() => { error = true })

      this.waivers.forEach(e => {
        this.celebration.waivers += parseFloat(e.amount)
      })

      this.credits.forEach(e => {
        this.celebration.transfers_credit += parseFloat(e.amount)
      })

      this.debits.forEach(e => {
        this.celebration.transfers_debit += parseFloat(e.amount)
      })

      this.withdrawsData.forEach(e => {
        this.celebration.withdraws += parseFloat(e.amount)
      })

      this.heppiPlanData.forEach(e => {
        this.celebration.heppiPlan += parseFloat(e.amount)
      })

      this.cashbackData.forEach(e => {
        this.celebration.cashback += parseFloat(e.amount)
      })
      // if (this.celebration.cashback > 0) {
      //   this.celebration.available_balance -= this.celebration.cashback
      // }

      this.loading = false

      if (error) {
        this.error = true
      } else {
        setTimeout(() => {
          window.print()
        }, 1000)
      }
    } else {
      this.error = true
    }

    this.now = this.$moment().format('DD/MM/YYYY HH:mm')
  }
}
</script>

<style>
.container-print tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .02);
 }

.container-print {
  padding: 30px;
}

@media print {
  .container-print {
    padding: 0 1cm;
    margin-top: -1cm;
  }
}

@page { margin: 1cm !important } /* All margins set to 2cm */

</style>
